// extracted by mini-css-extract-plugin
module.exports = {"line-separator":"LineSeparator_line-separator__1zRFn"};